import Fuse from 'fuse.js'
import deburr from 'lodash/deburr'
import escape from 'lodash/escape'
import escapeRegExp from 'lodash/escapeRegExp'

export interface SearchOption {
  id: number | string
  name: string
  html?: string
}

const MAX_LENGTH_OPTIONS = 100

export const highlightKeyword: (sentence: string, keyword?: string) => string = (
  sentence,
  keyword
) => {
  const expr = new RegExp(
    escapeRegExp(escape(keyword))
      .trim() // remove blank space before and after to avoid blank word
      .split(' ') // split string into words
      .filter(val => val.length > 0) // remove empty strings from the array
      .map(val => `(?:${val})`) // group for regexp ex: bar --> (?:bar) --> group of exact word
      .join('|'), // join regexp with OR to find all the words
    'gmi' // options for g --> global search, m --> multiline, i --> case insensitive
  )
  return escape(sentence).replace(expr, '<b>$&</b>')
}

export const getHighlightedSuggestions = (options: SearchOption[], value?: string) => {
  const deburredOptions = options.map(option => ({ ...option, name: deburr(option.name) }))

  return new Fuse(deburredOptions, {
    shouldSort: true,
    findAllMatches: true,
    threshold: 0.2,
    location: 0,
    distance: 50,
    minMatchCharLength: 1,
    keys: ['name'],
  })
    .search(deburr(value?.trim()))
    .slice(0, MAX_LENGTH_OPTIONS)
    .map(({ item }) => {
      const matchingOptionWithAccents = options.find(option => option.id === item.id)
      return matchingOptionWithAccents
        ? {
            ...item,
            name: matchingOptionWithAccents.name,
            html: highlightKeyword(matchingOptionWithAccents.name, value),
          }
        : item
    })
}
